import React, { useState, useRef } from "react";
import { Tabs, Tab, Col, Row, Pagination, Button } from "react-bootstrap";
import SurveyBarChart from "./charts/SurveyBarChart";
import QuestionBarChart from "./charts/QuestionBarChart";
import { GetToken } from "../common/getToken";
import { useNavigate, useParams, Link } from "react-router-dom";
import QuestionModal from "./QuestionModal";
import AllQuestionsGrid from "./Grid/AllQuestionsGrid";
import { FaLongArrowAltLeft } from "react-icons/fa";
import GraphQuestionsGrid from "./Grid/GraphQuestionsGrid";
import axios from "axios";
import Swal from "sweetalert2";
import { useEffect } from "react";
import { QuestionType, OrderBy, DateRange } from "./Filter";
import moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import { PdfSurveyStartDate, PdfSurveyEndDate } from "../common/DateFormat";

const SurveyAnalyticsTab = ({
  overview,
  surveyDetails,
  BASE_URL,
  surveyId,
}) => {
  const { REACT_APP_BASE_URL } = process.env;
  const { REACT_APP_API_URL } = process.env;
  const { REACT_APP_ANALYTICS_BASE_URL } = process.env;

  /* variable declarations */
  pdfMake.vfs = pdfFonts.vfs;
  let history = useNavigate();
  const childRef = useRef();
  const [modalShow, setModalShow] = useState(false);
  const [questionId, setQuestionId] = useState();
  const [questionText, setQuestionText] = useState();
  const [popupdata, setpopupdata] = useState([]);
  const [allQuestions, setAllQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingTabSecond, setLoadingTabSecond] = useState(false);
  const [nodata, setNodata] = useState(false);
  const [detailGraph, setDetailGraph] = useState([]);
  const [questionTypes, setQuestionTypes] = useState([]);
  const [activeTab, setActiveTab] = useState("surveyAnalytics");
  const [activePage, setActivePage] = useState(() => 1);
  const [PageNumberCount, setPageNumberCount] = useState(() => 1);
  const [limit, setLimit] = useState(() => 1);
  const [answerTypeId, setAnswerTypeId] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [sortBy, setSortBy] = useState();
  const [totalQuestions, setTotalQuestions] = useState();
  const [overviewData, setOverviewData] = useState([]);
  const [filterButton, setFilterButton] = useState("side");

  let items = [];
  let questions = "Total Questions:";
  let response = "Total Responses:";
  let surveyees = "Total Respondents:";

  for (let number = 1; number <= Math.ceil(totalQuestions / 5); number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === activePage}
        onClick={() => setLimit(number)}
      >
        {number}
      </Pagination.Item>,
    );
  }

  useEffect(() => {
    getSurveyAnalytics(surveyId);
  }, [
    allQuestions,
    history,
    surveyId,
    limit,
    answerTypeId,
    startDate,
    endDate,
    sortBy,
  ]);

  const getQuestionAnalytics = async (surveyId) => {
    const detailGraphsPageChange = async (
      Limit = 1,
      AnswerTypeId,
      StartDate, //"2021-07-20"
      EndDate,
      SortBy,
    ) => {
      setLoadingTabSecond(true);
      await axios
        .post(
          `${REACT_APP_API_URL}/getQuestionAnalytics`,
          {
            SurveyId: surveyId,
            Limit: Limit,
            AnswerTypeId: AnswerTypeId,
            StartDate: StartDate,
            EndDate: EndDate,
            SortBy: SortBy,
          },
          {
            headers: {
              authorization: GetToken(),
            },
          },
        )
        .then(async (result) => {
          if (result.data.code === 200) {
            setDetailGraph(result.data.data);
            setQuestionTypes(result.data.data.questionTypes);
            setActivePage(limit);
            setTotalQuestions(result.data.data.totalQuestions);
          } else {
            history.goBack();
          }
          setLoadingTabSecond(false);
        })
        .catch((err) => {
          setLoadingTabSecond(false);
          if (err.response) {
            Error(err.response.status, err.response.data.message);
          } else if (err.request) {
            Error(err.request.status, err.request.data.message);
          } else {
            Error(404, "Something went wrong.");
          }
        });
      window.scrollTo(0, 0);
    };
    detailGraphsPageChange(limit, answerTypeId, startDate, endDate, sortBy);
  };

  const getSurveyAnalytics = async (surveyId) => {
    setLoading(true);
    setNodata(true);
    axios
      .get(`${REACT_APP_API_URL}/getSurveyAnalytics/${surveyId}`, {
        headers: {
          authorization: GetToken(),
        },
      })
      .then(async (result) => {
        if (result.status === 200) {
          if (result.data.data) {
            setLoading(false);
            setNodata(false);
            if (result.data.message) {
              Swal.fire({
                title: result.data.message,
                icon: "error",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Back",
                cancelButtonText: "Cancel",
              }).then((result) => {
                if (result.isConfirmed) {
                  history.goBack();
                }
              });
            } else if (result.data.data) {
              // setUserSurveys(result.data.data.UserSurveys);
              // setSurveyDetails(result.data.data.surveyDetails);
              setOverviewData(
                result.data.data.surveyAnalytics.map((p, index) => ({
                  Question: index + 1,
                  ...p,
                })),
              );
              //  getQuestionAnalytics(surveyId);
            } else {
              history.goBack();
            }
          } else {
            Error(404, "No data found.");
            history.goBack();
          }
        } else {
          setNodata(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        setNodata(false);
        if (err.response) {
          if (err.response.status === 401) {
            /*
            Swal.fire({
              title: "Unauthorized Access",
              // text: "Please login",
              icon: "error",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Login",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location = `${REACT_APP_ANALYTICS_BASE_URL}/authLogin/${surveyId}`;
              }
            });
            */
          } else {
            Error(err.response.status, err.response.data.message);
          }
        } else {
          Error(404, "Something went wrong.");
        }
      });
  };
  useEffect(() => {
    if (activePage === 1) {
      setPageNumberCount(activePage);
    } else {
      let a = 0;
      for (let i = 1; i < activePage; i++) {
        a = a + 5;
      }
      setPageNumberCount(a + 1);
    }
  }, [activePage]);

  const changeFilterBox = async () => {
    if (filterButton == "hide") {
      setFilterButton("show");
    } else {
      setFilterButton("hide");
    }
  };

  useEffect(() => {
    if (allQuestions.length) {
      const doc = {
        // userPassword: "123",
        // ownerPassword: "123456",
        // permissions: {
        //   printing: "highResolution", //'lowResolution'
        //   modifying: false,
        //   copying: false,
        //   annotating: true,
        //   fillingForms: true,
        //   contentAccessibility: true,
        //   documentAssembly: true,
        // },

        info: {
          title: surveyDetails.SurveyName,
        },
        pageSize: "A4",
        pageOrientation: "portrait",
        pageMargins: [30, 30, 30, 60],
        content: [],

        footer: function (currentPage, pageCount) {
          return {
            margin: [30, 30, 30, 0],
            columns: [
              {
                text: "Powered by",
                alignment: "left",
                color: "#3d3d3d",
                fontSize: 9,
              },
              {
                text: "OpenEyes Technologies Inc.",
                alignment: "left",
                color: "#00aef3",
                fontSize: 9,
                margin: [-129, 0, 0, 0],
                link: "https://theopeneyes.com/",
              },
              {
                text: currentPage.toString() + " of " + pageCount,
                color: "#3d3d3d",
                alignment: "right",
                fontSize: 9,
              },
              // {
              //   text: "Powered by OpenEyes Surveys",
              //   alignment: "left",
              //   color: "#3d3d3d",
              //   fontSize: 10,
              //   link: "https://theopeneyes.com/",
              // },
              // {
              //   text: currentPage.toString() + " of " + pageCount,
              //   color: "#3d3d3d",
              //   alignment: "right",
              //   fontSize: 10,
              //   // link: "https://theopeneyes.com/",
              // },
            ],
          };
        },
      };

      //survey name
      doc.content.push({
        width: "100%",
        text: surveyDetails.SurveyName,
        alignment: "center",
        fontSize: 14,
        fontWeight: 600,
        margin: [0, 0, 0, 15],
      });

      //dates
      doc.content.push({
        margin: [0, 7, 0, 0],
        alignment: "center",
        backgroundColor: "#fff",
        columns: [
          {
            text: PdfSurveyStartDate(surveyDetails.StartDate),
            fontSize: 9,
          },
          {
            text: PdfSurveyEndDate(surveyDetails.ExpiryDate),
            fontSize: 9,
          },
          {
            text: "Downloaded On:\n" + moment().format("MM/DD/YYYY h:mm A"),
            fontSize: 9,
          },
          // {
          //   text: "Status",
          //   fontSize: 10,
          // },
        ],
        columnGap: 30,
      });

      //border jugad
      doc.content.push({
        alignment: "center",
        margin: [0, 30, 0, 0],
        columns: [
          {
            text: "Total Respondents: " + surveyDetails.uniqueUsers,
            color: "#ffffff",
            fontSize: 10,
            // characterSpacing: 3,
            decoration: "overline",
            decorationColor: "#3d3d3c",
            decorationStyle: "line",
          },
          {
            text: "Total Questions: " + surveyDetails.totalQuestions,
            color: "#ffffff",
            fontSize: 10,
            // characterSpacing: 3,
            decoration: "overline",
            decorationColor: "#3d3d3c",
            decorationStyle: "line",
          },
          {
            text: "Total Responses: " + surveyDetails.totalquestionResponses,
            color: "#ffffff",
            fontSize: 10,
            // characterSpacing: 3,
            decoration: "overline",
            decorationColor: "#3d3d3c",
            decorationStyle: "line",
          },
        ],
        columnGap: 20,
      });

      //survey question & responses
      doc.content.push({
        alignment: "center",
        margin: [0, 0, 0, 0],
        columns: [
          {
            text: "Total Respondents: " + surveyDetails.uniqueUsers,
            fontSize: 10,
          },
          {
            text: "Total Questions: " + surveyDetails.totalQuestions,
            fontSize: 10,
          },
          {
            text: "Total Responses: " + surveyDetails.totalquestionResponses,
            fontSize: 10,
          },
        ],
        columnGap: 20,
      });

      //border jugad
      doc.content.push({
        alignment: "center",
        columns: [
          {
            text: "Total Respondents: " + surveyDetails.uniqueUsers + "\n\n",
            color: "#ffffff",
            fontSize: 10,
            // characterSpacing: 3,
            decoration: "underline",
            decorationColor: "#3d3d3c",
            decorationStyle: "line",
          },
          {
            text: "Total Questions: " + surveyDetails.totalQuestions + "\n\n",
            color: "#ffffff",
            fontSize: 10,
            // characterSpacing: 3,
            decoration: "underline",
            decorationColor: "#3d3d3c",
            decorationStyle: "line",
          },
          {
            text:
              "Total Responses: " +
              surveyDetails.totalquestionResponses +
              "\n\n",
            color: "#ffffff",
            fontSize: 10,
            // characterSpacing: 3,
            decoration: "underline",
            decorationColor: "#3d3d3c",
            decorationStyle: "line",
          },
        ],
        columnGap: 20,
      });

      //survey message
      doc.content.push({
        text:
          surveyDetails.SurveyStatus === "Closed"
            ? ""
            : "This data is not final as the survey is ongoing",
        alignment: "right",
        fontSize: 9,
        // margin: [-25, -25, 0, 0],
        // background: surveyDetails.SurveyStatus === "Closed" ? "#dc3545" : "#81d888",
        color: "#dc3545",
      });

      //survey descriptipn
      doc.content.push({
        text: surveyDetails.FormattedText,
        fontSize: 11,
        alignment: "left",
        margin: [0, 15, 0, 0],
      });

      //line space
      doc.content.push({
        width: 250,
        text: "\n\n",
        alignment: "center",
      });

      for (let i = 0; i < allQuestions.length; i++) {
        let tbl = [];
        let tblData = allQuestions[i].child;

        //Question text
        doc.content.push({
          text: i + 1 + ". " + allQuestions[i].QuestionText,
          fontSize: 11,
          alignment: "left",
          margin: [0, 15, 0, 0],
        });

        //line space
        doc.content.push({
          width: 250,
          text: "\n",
          alignment: "center",
        });

        {
          (() => {
            switch (allQuestions[i].AnswerTypeId) {
              case "b166063b-0740-11ec-af38-1908de41ac9c":
              case "b1662a30-0740-11ec-af38-1908de41ac9c":
              case "b1662e42-0740-11ec-af38-1908de41ac9c":
              case "ec856a6e-a071-4496-829e-ce407ad3d3fa":
                for (let j = 0; j < tblData.length; j++) {
                  if (j % 2 === 0) {
                    tbl.push([
                      {
                        text: tblData[j].index,
                        margin: [5, 5],
                        alignment: "center",
                      },
                      {
                        text: tblData[j].country,
                        margin: [5, 5],
                      },
                      {
                        text: tblData[j].responses,
                        margin: [5, 5],
                        alignment: "right",
                      },
                      {
                        text: tblData[j].visits,
                        margin: [5, 5],
                        alignment: "right",
                      },
                    ]);
                  } else {
                    tbl.push([
                      {
                        text: tblData[j].index,
                        fillColor: "#f5f5f5",
                        margin: [5, 5],
                        alignment: "center",
                      },
                      {
                        text: tblData[j].country,
                        fillColor: "#f5f5f5",
                        margin: [5, 5],
                      },
                      {
                        text: tblData[j].responses,
                        fillColor: "#f5f5f5",
                        margin: [5, 5],
                        alignment: "right",
                      },
                      {
                        text: tblData[j].visits,
                        fillColor: "#f5f5f5",
                        margin: [5, 5],
                        alignment: "right",
                      },
                    ]);
                  }
                }

                // table;
                doc.content.push({
                  // layout: "lightHorizontalLines",
                  fontSize: 11,
                  table: {
                    headerRows: 1,
                    widths: ["*", 250, 120, 75],
                    body: [
                      [
                        {
                          text: "#",
                          fillColor: "#32c5ff",
                          color: "white",
                          alignment: "center",
                          margin: [5, 5],
                        },
                        {
                          text: "Option",
                          fillColor: "#32c5ff",
                          color: "white",
                          alignment: "left",
                          margin: [5, 5],
                        },
                        {
                          text: "Number of Responses",
                          fillColor: "#32c5ff",
                          color: "white",
                          alignment: "right",
                          margin: [5, 5],
                        },
                        {
                          text: "Responses %",
                          fillColor: "#32c5ff",
                          color: "white",
                          alignment: "right",
                          margin: [5, 5],
                        },
                      ],
                      ...tbl,
                    ],
                  },
                });
              default:
                for (let j = 0; j < tblData.length; j++) {
                  if (j % 2 === 0) {
                    tbl.push([
                      {
                        text: tblData[j].index,
                        margin: [5, 5],
                        alignment: "center",
                      },
                      {
                        text: tblData[j].AnswerText,
                        margin: [5, 5],
                      },
                    ]);
                  } else {
                    tbl.push([
                      {
                        text: tblData[j].index,
                        fillColor: "#f5f5f5",
                        margin: [5, 5],
                        alignment: "center",
                      },
                      {
                        text: tblData[j].AnswerText,
                        fillColor: "#f5f5f5",
                        margin: [5, 5],
                      },
                    ]);
                  }
                }

                // table;
                doc.content.push({
                  // layout: "lightHorizontalLines",
                  fontSize: 11,
                  table: {
                    headerRows: 1,
                    widths: ["*", "*"],
                    body: [
                      [
                        {
                          text: "#",
                          fillColor: "#32c5ff",
                          color: "white",
                          alignment: "center",
                          margin: [5, 5],
                        },
                        {
                          text: "Responses",
                          fillColor: "#32c5ff",
                          color: "white",
                          alignment: "left",
                          margin: [5, 5],
                        },
                      ],
                      ...tbl,
                    ],
                  },
                });
            }
          })();
        }
      }
      pdfMake
        .createPdf(doc)
        .download(
          surveyDetails.SurveyName != ""
            ? surveyDetails.SurveyName.split(" ")
                .join("")
                .replace(/\s+/g, "-") +
                "-Report-" +
                moment().format("MM-DD-YYYY-hh-mm") +
                ".pdf"
            : "Survey-Report-" + moment().format("MM-DD-YYYY-hh-mm") + ".pdf",
        );
    }
  }, [allQuestions, surveyDetails]);

  return (
    <>
      <center
        style={{ paddingTop: "20vh" }}
        className={loading ? "" : "d-none"}
      >
        <br />
        <h4>Loading...</h4>
      </center>
      <div className={!loading ? "" : "d-none"}>
        <div className="graph-main">
          {surveyDetails.totalQuestions > 0 ? (
            <>
              <div className="intro-text">
                Find the analysis summary of all survey questions with the
                number of respondent details here.
              </div>
              <SurveyBarChart
                forward={childRef}
                surveyDetails={surveyDetails}
                chartData={overviewData}
                Key={"Question"}
                Value={"totalquestionResponses"}
                divId={"QuestionText"}
              />
            </>
          ) : (
            <>
              <small class="d-block text-danger mt-1 fw-light">
                {" "}
                No response record found for this question
              </small>
            </>
          )}
        </div>
        <div>
          <AllQuestionsGrid
            overview={overviewData}
            surveyDetails={surveyDetails}
          />
        </div>
      </div>
    </>
  );
};

export default SurveyAnalyticsTab;
